<script>
export default {
  name: 'StoreFunctions',
  methods: {
    getDispatchFormItems (form) {
      let formItems = []
      form.form_sections.forEach(section => {
        const filteredFormItems = section.form_items.filter(formItem =>
          formItem.active > 0 &&
          formItem.options_json &&
          (formItem.options_json.dispatch_display > 0 || formItem.options_json.customdb)
        )
        filteredFormItems.forEach(formItem => {
          formItem.form_id = form.form_id
          formItem.form_section_id = section.form_section_id
        })
        formItems = formItems.concat(filteredFormItems)
      })
      return formItems.sort(this.sortDispatchFormItems)
    },
    sortDispatchFormItems (x, y) {
      if (x.options_json.dispatch_display && x.options_json.dispatch_display && x.options_json.dispatch_display !== y.options_json.dispatch_display) {
        return x.options_json.dispatch_display > y.options_json.dispatch_display ? 1 : -1
      }
      return 0
    },
    loadAdditionalFilesToStore (fileIds, appendToFile, url) {
      return new Promise((resolve, reject) => {
        const fileIdsAlreadyLoaded = Object.keys(this.$store.getters.files).map(fileId => parseInt(fileId))
        const fileIdsToLoad = fileIds.filter(fileId => !fileIdsAlreadyLoaded.includes(fileId))
        const loadedFiles = []
        const promises = []
        if (fileIdsToLoad.length > 0) {
          const chunk = 100
          let temp = []
          for (let i = 0; i < fileIdsToLoad.length; i += chunk) {
            temp = fileIdsToLoad.slice(i, i + chunk)
            promises.push(
              this.fetchNest((url || 'api/v2/files/') + temp.join(','))
                .then(response => {
                  if (response !== null) {
                    if (appendToFile) {
                      response.items.forEach(file => {
                        for (const key in appendToFile) {
                          file[key] = appendToFile[key]
                        }
                      })
                    }
                    loadedFiles.push(...response.items)
                    this.$store.dispatch('addFiles', response.items)
                  }
                }).catch((reason) => { reject(reason) })
            )
          }
        }
        Promise.all(promises).then(function (data) {
          resolve(loadedFiles)
        }).catch((reason) => { reject(reason) })
      })
    },
    loadFilesToStoreWithLoadingState (fileIds) {
      const fileIdsToLoad = []
      fileIds.forEach(fileId => {
        if (fileId && !this.$store.getters.fileById(fileId)) {
          this.$store.dispatch('addFile', { file_id: fileId, state: 'loading' })
          fileIdsToLoad.push(fileId)
        }
      })
      if (fileIdsToLoad.length) {
        this.fetchNest('api/v2/files/' + fileIdsToLoad.join(','))
          .then(response => {
            if (response !== null) {
              this.$store.dispatch('addFiles', response.items)
            }
          })
      }
    }
  }
}
</script>
